import { images } from "../shared/Images.js";

function Products() {
  return (
    <>
      <div className="row content-left pt-4">
        <div className="col-lg-6 text-col text-left">
          <h3 className="section-subtitle intro-heading">
            <strong>Wholesale&nbsp;</strong>/&nbsp;Diesel
          </h3>
          <h2 className="section-title">
            <div className="main-heading">
              Top-quality supply
              <br />
              On-demand
            </div>
          </h2>
          <p className="text-secondary">
            Diesel 10ppm
            <br />
            Diesel 50ppm
          </p>
        </div>
        <div className="col-lg-6 img-col">
          <img src={images.product1} alt="product-1" title="" />
          <div className="section-btn btn-vertical">
            <a className="btn text-white text-left" href="https://mobirise.co/">
              Save On Our Bulk Deals
            </a>
          </div>
        </div>
      </div>

      <div className="row content-right">
        <div className="col-lg-6 img-col">
          <img src={images.product2} alt="product-2" title="" />
          <div className="section-btn btn-horizontal">
            <a className="btn text-white" href="https://mobirise.co/">
              ULP/LRP 93 &amp; 95
            </a>
          </div>
        </div>
        <div className="col-lg-6 text-col text-left">
          <h3 className="section-subtitle intro-heading">
            <strong>Wholesale&nbsp;</strong>/&nbsp;Petrol
          </h3>
          <h2 className="section-title main-heading">
            Fleet Refuelling
            <br />
            On-demand
          </h2>
          <p className="text-secondary">
            Unleaded petrol (ULP) 93
            <br />
            Unleaded petrol (ULP) 95
            <br />
          </p>
        </div>
      </div>

      <div className="row content-left pb-4">
        <div className="col-lg-6 text-col text-left">
          <h3 className="section-subtitle intro-heading">
            <strong>Wholesale&nbsp;</strong>/&nbsp;Illuminating Paraffin
          </h3>
          <h2 className="section-title">
            <div className="main-heading">
              Fuel for domestic
              <br />
              burners
            </div>
          </h2>
          <p className="text-secondary">
            Illuminating Paraffin is a low sulphur Fuel Oil, synthetic derived
            used to fuel for domestic burners &amp; flueless space heaters.
          </p>
        </div>
        <div className="col-lg-6 img-col">
          <img src={images.product3} alt="product-1" title="" />
          <div className="section-btn btn-vertical">
            <a className="btn text-white text-left" href="https://mobirise.co/">
              Best price possible
            </a>
          </div>
        </div>
      </div>
    </>
  );
}

export default Products;
